/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForSaasAwsAccessKeyProtocol extends models.ServiceAccountCredentialsBaseForSaasAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaasAwsAccessKeyProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForSaasAwsAccessKeyProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForSaasAwsAccessKeyProtocol>): ServiceAccountCredentialsForSaasAwsAccessKeyProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForSaasAwsAccessKeyProtocol(), model);
        ServiceAccountCredentialsForSaasAwsAccessKeyProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForSaasAwsAccessKeyProtocol>): ServiceAccountCredentialsForSaasAwsAccessKeyProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForSaasAwsAccessKeyProtocol.newInstance(<ServiceAccountCredentialsForSaasAwsAccessKeyProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForSaasAwsAccessKeyProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForSaasAwsAccessKeyProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForSaasAwsAccessKeyProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForSaasAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForSaasAwsAccessKeyProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Key Id. This is a required field.
     */
    access_key: string;

    /**
     * Secret Access Key Id. This is a required field.
     */
    secret_key: string;

}
